import {useAbTestUserIdCookie} from '@aboutyou/feature-flags';
import {useCookie} from '@aboutyou/storage';

const GA_SESSION_ID_COOKIE_NAME = '_ga';

export const useUniqueTrackingSessionId = (): string => {
  const [abTestUserId] = useAbTestUserIdCookie();
  const [gaSessionId] = useCookie({
    cookieName: GA_SESSION_ID_COOKIE_NAME,
    defaultValue: '',
    transformRawValue: rawValue => rawValue,
  });
  return `${gaSessionId}|${abTestUserId}`;
};
